export default "__VITE_ASSET__DXt4wWfP__ 120w, __VITE_ASSET__oYavZfjI__ 240w, __VITE_ASSET__Dlmru7Og__ 480w, __VITE_ASSET__XoGEPHUO__ 512w";